import { useContext, useEffect } from 'react'
import type { ReactNode } from 'react'
import { PageHeaderContext } from '../components/Layout/PageHeaderContext'

export function usePageHeader(title: ReactNode, actions?: ReactNode) {
  const { setHeader } = useContext(PageHeaderContext)
  useEffect(() => {
    setHeader(title, actions ?? null)
  }, [title, actions, setHeader])

  // Clear header when this page unmounts (guards against lingering title on pages
  // that don't call usePageHeader, like external redirects).
  useEffect(() => {
    return () => setHeader('')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
